<template>
  <div class="home">
<div class="works">

	<div class="works-ban">
		<h2>Appreciation Works</h2>
		<p>Home / Appreciation Works</p>
		<p><span :class="{'acts':channel_id==3}" @click="buff(3)">game player</span><span :class="{'acts':channel_id==4}" @click="buff(4)"> appreciation </span><span :class="{'acts':channel_id==1}" @click="buff(1)">works </span></p>
	</div>
	<div class="home-ct">
<div class="wok-con">

	<waterfall :col="4" :data="data" height="800px" width="217" >
	  <template>
	    <div
	      class="pr pbImgBox"
	      v-for="(item,index) in data"
	      :key="index"
	    > 
		<router-link :to="'detail?id='+item.id">
		 <div class="pic"> 
		 <div class="plu">
			 <img src="../../assets/plu.png" />
		 </div>
		 <div class="sem"></div><img class="base" v-if="item.originalPic" :lazy-src="item.originalPic"  /></div>
	
	  
	      <p class="l1"><span >{{item.title}}</span></p>
		   <p class="l2"><span >{{item.content}}</span></p>
		   </router-link>
	    </div>
	  </template>
	</waterfall>
	
 </div>

		</div>
</div>
  
    </div>
</template>
<script>

export default {

  data() {
    return {

    data:[],
	channel_id:0

    };
  }, computed:{
	      itemWidth(){  
	            return (138*0.5*(document.documentElement.clientWidth/375)) 
	      },
	      gutterWidth(){
	            return (9*0.5*(document.documentElement.clientWidth/375))	
	      }
	    },
 mounted() {
	 
	 

	  

		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsList",
			  data: {content_len:'60',channel_id:this.channel_id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
			
									
					this.data=data.data;
					
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},buff(item){
				this.channel_id=item
				this.sandMate()
			}
		}
};
</script>
<style lang="scss" scoped>

.works{
	.wok-con{
		margin-top: 30px;
		.l1{
			line-height: 40px;
		}
		.l2{
			color: #8E8D8D;
		}
		.pic{
			margin-top: 20px;
			position: relative;
			overflow: hidden;
			.plu{
				position: absolute;
				width: 33px;
				height: 33px;
				z-index: 999;
				opacity: 0;
				left: 12px;
				top: 0;
				transition: all 0.5s;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.sem{
				width: 80%;
				height: 80%;
				border: 1px solid #FFFFFF;
				position: absolute;
				z-index: 100;
				top: 10%;
				left: 10%;
				opacity: 0;
				transition: all 0.5s;
			}
		
			img{
				width: 100%;
				transition: all 0.5s;
			}
			
		}
		.pic:hover{
			.base{
				 transform: scale(1.2);
			}
			.sem{
				opacity: 0.5;
			
			}
			.plu{
				opacity: 1;
				top: 20%;
			}
			
		}
		
	}


	.works-ban{
		padding-top: 30px;
		background: #0A0A0A;
		height: 157px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
	.works-con{
		margin-top: 20px;
		ul{
			display: flex;
			flex-wrap: wrap;
			li{
				margin: 0 1%;
				width: 23%;
				.pic{
					img{
						width: 100%;
					}
				}
				.txt{
					h6{
						margin: 10px 0;
					}
					p{
						color: #8E8D8D;
					}
				}
			}
		}
		
	}
}

</style>